import type { SelectOptionType } from '@danfoss/mosaic-core';

export const PRODUCTS: SelectOptionType[] = [
    { value: 'software', label: 'PLUS+1 Software' },
    { value: 'connect', label: 'PLUS+1 Connect' },
    { value: 'guideTraining', label: 'PLUS+1 Guide Training' },
    { value: 'hardware', label: 'PLUS+1 Hardware' },
    { value: 'marketplace', label: 'PLUS+1 Marketplace' },
    { value: 'radioRemoteControl', label: 'PLUS+1 Radio Remote Control' },
    { value: 'guide', label: 'PLUS+1 Guide' },
    { value: 'service', label: 'PLUS+1 Service' },
    { value: 'mobilesev', label: 'PLUS+1 Mobile Service' },
    { value: 'updatec', label: 'PLUS+1 Update Center' },
    { value: 'license', label: 'PLUS+1 License' },
    { value: 'dip', label: 'MyDanfoss Account' },

];

export const SUPPORT: SelectOptionType[] = [
    { value: 'Product Technical Support', label: 'Product Technical Support' },
    { value: 'Pricing Order Support', label: 'Pricing Order Support' },
    { value: 'Commercial Support', label: 'Commercial Support' },
    { value: 'System Technical Support', label: 'System Technical Support' },
];

export default PRODUCTS;